import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';

@Component({
  selector: 'page-library-select',
  templateUrl: 'library-select.component.html'
})
export class LibrarySelectPageComponent implements OnInit, AfterViewInit {
  public key: any;
  public alive = true;
  public data = [];
  public searchStr = null;

  constructor(
    public params: NavParams,
    public resumeService: ResumeService,
    public viewCtrl: ViewController
  ) {
    this.key = params.get('key');
  }

  ngOnInit() {
    this.getData(true);
  }

  ngAfterViewInit(){
    let elm = <HTMLInputElement>document.querySelector('#librarySearch input');
    if(elm)
      elm.focus();
  }

  dismiss() {
    this.selectedItem(null);
  }

  ngOnDestroy() {
    this.alive = false;
  }

  selectedItem(item) {
    if (item) {
      this.setKey(item);
    }
    this.viewCtrl.dismiss(item);
  }

  getItems(ev) {
    var val = ev.target.value.trim();
    this.searchStr = val;
    if (val && val != '' && val.length > 1) {
      this.getData(true);
    } else {
      this.data = [];
    }
  }

  private setKey(item) {
    if (this.key == 'CertificationName') {
      item.key = 'certificationFK';
    } else if (this.key == 'Institute') {
      item.key = 'instituteFK';
    } else if (this.key == 'SkillName') {
      item.key = 'skillFK';
    }
  }

  private getData(clear) {
    var subs = null;
    if (this.key == 'CertificationName') {
      subs = this.resumeService.getCertificationsList(1, -1, this.searchStr);
    } else if (this.key == 'Institute') {
      subs = this.resumeService.getSchoolsList(1, -1, this.searchStr);
    } else if (this.key == 'SkillName') {
      subs = this.resumeService.getSkillsList(1, -1, this.searchStr);
    }
    subs.takeWhile(() => this.alive)
      .subscribe((obj: any) => {
        if (clear) {
          this.data = obj.lookups;
        } else {
          this.data = this.data.concat(obj.lookups);
        }
      }, err => {
        console.log("error in fetching library obj", err);
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/library-select/library-select.component.ts